import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'MobileOrderSummary.title',
    description: 'Title for the mobile order summary flyout',
    defaultMessage: 'Items You\'re Purchasing',
  },
  buttonBackLabel: {
    id: 'MobileOrderSummary.buttonBackLabel',
    description: 'Label for the back button in MobileOrderSummary flyout',
    defaultMessage: 'Back to Checkout',
  },
});
